export default "__VITE_ASSET__554b03fb__"